// src/shared/components/ui/button.tsx
import React from 'react'
import clsx from 'classnames'

export type ButtonVariant = 'default' | 'outline' | 'ghost'
export type ButtonSize = 'sm' | 'md' | 'lg'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
}

/**
 * A simple tailwind-styled button.
 */
export function Button({
  variant = 'default',
  size = 'md',
  className,
  ...props
}: ButtonProps) {
  const base = 'inline-flex items-center justify-center font-medium focus:outline-none focus:ring-2 focus:ring-offset-2'
  const variants: Record<ButtonVariant,string> = {
    default: 'bg-neutral-800 text-neutral-100 hover:bg-neutral-700 focus:ring-neutral-700',
    outline: 'border border-neutral-700 text-neutral-100 hover:bg-neutral-800 focus:ring-neutral-700',
    ghost: 'bg-transparent text-neutral-100 hover:bg-neutral-800 focus:ring-neutral-700',
  }
  const sizes: Record<ButtonSize,string> = {
    sm: 'px-2 py-1 text-sm',
    md: 'px-3 py-2 text-base',
    lg: 'px-4 py-3 text-lg',
  }
  
  return (
    <button
      className={clsx(base, variants[variant], sizes[size], className)}
      {...props}
    />
  )
}
